import { useEffect, useState } from "react"
import { DateTime } from "luxon"
import SidePanel from "../side-panel"
import {
  currentThread,
  showCurrentThreadDetailsView,
  toggleCurrentThreadDetailsView
} from "../../../redux/slices/conversations"
import { useSelector } from "react-redux"
import { Lead } from "../../../types"
import { useAppDispatch } from "../../hooks"
import {
  useLazyFetchLeadDetailsQuery,
  useLazyFetchSubscriptionDetailsQuery
} from "../../../redux/queries"
import LeadSummary from "../leads/details/sections/summary"
import If from "../if"

const ConversationLeadDetailsPanel = () => {
  const dispatch = useAppDispatch()

  const thread = useSelector(currentThread)
  const showView = useSelector(showCurrentThreadDetailsView)

  const [quoteDetails, setQuoteDetails] = useState<Lead>()

  const [
    fetchSubscriptionDetails,
    { data: subscriptionData, isFetching: isFetchingSubscriptionDetails }
  ] = useLazyFetchSubscriptionDetailsQuery()

  const [
    fetchLeadDetails,
    { data: leadData, isFetching: isFetchingLeadDetails }
  ] = useLazyFetchLeadDetailsQuery()

  useEffect(() => {
    if (thread?.item_id) {
      if (thread?.type === "subscription") {
        fetchSubscriptionDetails({ id: thread.item_id })
        //fetchSubscriptionDetails({ id: "85" })
      } else {
        //fetchLeadDetails("1738")
        fetchLeadDetails(thread.item_id)
      }
    }
  }, [thread, fetchSubscriptionDetails, fetchLeadDetails])

  useEffect(() => {
    if (subscriptionData && thread?.type === "subscription") {
      // lead

      if (subscriptionData.lead) {
        setQuoteDetails(subscriptionData.lead)
      } else {
        //we need to map values to match the "lead" type
        const {
          created,
          email,
          id,
          first_name,
          last_name,
          phone,
          quote_info: {
            loan_type,
            loan_term,
            arm_term,
            loan_purpose,
            loan_amount,
            credit_score,
            property_type,
            residency_type,
            list_price,
            property_value,
            cash_out,
            first_time_homebuyer,
            location
          }
        } = subscriptionData

        const lead: Partial<Lead> = {
          phone,
          email,
          id,
          first_name,
          last_name,
          date_time: DateTime.fromSeconds(Number(created)).toFormat(
            "yyyy-MM-dd'T'HH:mm:ss"
          ),
          owner: thread?.loan_officer.email ?? "",
          details: {
            loan_type,
            loan_term,
            arm_term,
            loan_purpose,
            loan_amount,
            credit_score,
            property_type,
            residency_type,
            list_price: list_price ?? property_value,
            cash_out,
            first_time_homebuyer,
            location
          }
        }

        setQuoteDetails(lead as Lead)
      }
    } else if (leadData && thread?.type === "lead") {
      setQuoteDetails(leadData)
    }
  }, [leadData, subscriptionData, thread?.loan_officer.email, thread?.type])

  const isFetching = isFetchingSubscriptionDetails || isFetchingLeadDetails

  const onClose = () => dispatch(toggleCurrentThreadDetailsView())

  return (
    <SidePanel open={showView} title="Lead Details" onClose={onClose}>
      <If
        isLoading={isFetching}
        condition={!!thread && quoteDetails !== undefined}
        then={
          <LeadSummary
            data={quoteDetails!}
            cols={3}
            dashLink={thread?.dashboard_link}
            openAccordionsByDefault={false}
          />
        }
      />
    </SidePanel>
  )
}

export default ConversationLeadDetailsPanel
